import React from 'react';

// Used by the section header and by each baseline dropdown option.
const CheckIcon = () => (
    <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.2' strokeLinecap='round' strokeLinejoin='round' aria-hidden='true'>
        <path d='M4 12.5l5.2 5.2L20 7' />
    </svg>
);

export default CheckIcon;
